import React, { useEffect } from "react";

/**
 * Gestileerde vervanging voor alert(). Render onderin het scherm, gestuurd
 * door een { message, type } state-object in het bevattende component:
 *
 *   const [toast, setToast] = useState(null); // { message, type }
 *   const showToast = (message, type = "success") => setToast({ message, type });
 *   ...
 *   <Toast toast={toast} onClose={() => setToast(null)} />
 *
 * type: "success" | "error" | "info"
 */
export default function Toast({ toast, onClose, duration = 4000 }) {
  useEffect(() => {
    if (!toast) return undefined;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [toast, onClose, duration]);

  if (!toast) return null;

  const palette = {
    success: { bg: "#1E7B34", icon: "✅" },
    error: { bg: "#B3261E", icon: "⚠️" },
    info: { bg: "#3A4A68", icon: "ℹ️" },
  }[toast.type || "success"];

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        bottom: "24px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 3000,
        maxWidth: "90vw",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          background: palette.bg,
          color: "white",
          padding: "14px 20px",
          borderRadius: "12px",
          boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
          fontSize: "14px",
          fontWeight: 500,
        }}
      >
        <span>{palette.icon}</span>
        <span>{toast.message}</span>
        <button
          onClick={onClose}
          aria-label="Sluiten"
          style={{
            background: "transparent",
            border: "none",
            color: "white",
            opacity: 0.8,
            cursor: "pointer",
            fontSize: "16px",
            marginLeft: "6px",
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
}
